import { createSlice } from '@reduxjs/toolkit';
import {
  getCandidateInfoThunk,
  getCandidateListThunk,
  getCandidateMetaThunk, // ! smth notifications related
  getCandidatePreviewThunk,
} from './Candidate.thunk';

export const candidateSlice = createSlice({
  name: 'candidate',
  initialState: {
    list: { //TODO: list of what? presumably, list of records(ak phases/stages)
      items: [],
      loading: true,
      pagination: {},
    },
    isEditCandidate: false,
    selected: { // ! selected vs selectedForPreview в чём разница?
      item: undefined,
      loading: false,
    },
    selectedForPreview: {
      item: undefined,
      loading: false,
    },
    meta: { // ! smth notifications related
      items: undefined,
      loading: true,
    },
  },
  reducers: {
    resetCandidateListAction: (state, action) => ({
      ...state,
      list: {
        ...state.list,
        items: [],
        pagination: {},
      },
    }),
    resetCandidateSelectedAction: (state, action) => ({
      ...state,
      selected: {
        ...state.selected,
        item: undefined,
      },
    }),
    setIsEditCandidateAction: (state, action) => ({
      ...state,
      isEditCandidate: action.payload,
    }),
    resetCandidateSelectedForPreviewAction: (state, action) => ({
      ...state,
      selectedForPreview: {
        ...state.selectedForPreview,
        item: undefined,
      },
    }),
    setCandidateSelectedAction: (state, action) => ({
      ...state,
      selected: {
        ...state.selected,
        item: action.payload,
        loading: false,
      },
    }),
    setCandidateMetaAction: (state, action) => ({ // ! smth notifications related
      ...state,
      meta: {
        items: action.payload,
        loading: false,
      },
    }),
  },
  extraReducers: builder => {
    // Start Candidate Meta
    builder.addCase(getCandidateMetaThunk.pending, (state, action) => { // ! smth notifications related
      state.meta = { ...state.meta, loading: true };
    });
    builder.addCase(getCandidateMetaThunk.fulfilled, (state, action) => { // ! smth notifications related
      state.meta = {
        ...state.meta,
        items: { ...action.payload },
        loading: false,
      };
    });
    builder.addCase(getCandidateMetaThunk.rejected, (state, action) => { // ! smth notifications related
      // state.meta = { ...state.meta, loading: false };
    });
    // End Candidate meta
    // Start Candidates List
    builder.addCase(getCandidateListThunk.pending, (state, action) => {
      state.list = { ...state.list, loading: true };
    });
    builder.addCase(getCandidateListThunk.fulfilled, (state, action) => {
      const { data, pagination: _pagination } = action.payload;
      const pagination = {
        currentPage: _pagination.current_page,
        lastPage: _pagination.last_page,
        total: _pagination.total,
      };
      state.list = { ...state.list, items: data, pagination, loading: false };
    });
    builder.addCase(getCandidateListThunk.rejected, (state, action) => {
      // state.list = { ...state.list, loading: false };
    });
    // End Candidates List
    // Start Candidate Preview Info
    builder.addCase(getCandidatePreviewThunk.pending, (state, action) => {
      state.selectedForPreview = {
        ...state.selectedForPreview,
        item: undefined,
        loading: true,
      };
    });
    builder.addCase(getCandidatePreviewThunk.fulfilled, (state, action) => {
      state.selectedForPreview = {
        ...state.selectedForPreview,
        item: action.payload,
        loading: false,
      };
    });
    builder.addCase(getCandidatePreviewThunk.rejected, (state, action) => {
      // state.selected = { ...state.selected, loading: true };
    });
    // End Candidate Preview Info
    // Start Candidate Info
    builder.addCase(getCandidateInfoThunk.pending, (state, action) => {
      state.selected = { ...state.selected, item: undefined, loading: true };
    });
    builder.addCase(getCandidateInfoThunk.fulfilled, (state, action) => {
      state.selected = {
        ...state.selected,
        item: action.payload,
        loading: false,
      };
    });
    builder.addCase(getCandidateInfoThunk.rejected, (state, action) => {
      // state.selected = { ...state.selected, loading: true };
    });
    // End Candidate Info
  },
});

export const {
  setCandidateSelectedAction,
  setCandidateMetaAction, // ! smth notifications related
  resetCandidateListAction,
  resetCandidateSelectedAction,
  resetCandidateSelectedForPreviewAction,
  setIsEditCandidateAction,
} = candidateSlice.actions;

export const getCandidatesMeta = (state: any) => state.candidate.meta; // ! smth notifications related
export const getCandidatesList = (state: any) => state.candidate.list;
export const getCandidateSelected = (state: any) => state.candidate.selected; // ! мы это на onClick в стейт сетим?
export const getIsEditCandidate = (state: any) =>
  state.candidate.isEditCandidate;
export const getCandidateSelectedForPreview = (state: any) =>
  state.candidate.selectedForPreview;

export default candidateSlice.reducer;
